import React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import './Dialogs.scss';

interface OffboardConfirmDialogProps {
  isOpen: boolean;
  participantId: string;
  isRejoining?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const OffboardConfirmDialog: React.FC<OffboardConfirmDialogProps> = ({
  isOpen,
  participantId,
  isRejoining = false,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  const title = isRejoining ? 'Rejoin Participant' : 'Offboard Participant';
  const message = isRejoining
    ? `Are you sure you want to rejoin ${participantId}?`
    : `Are you sure you want to offboard ${participantId}?`;
  const buttonText = isRejoining ? 'Rejoin participant' : 'Offboard participant';

  return (
    <Dialog title={title} onClose={onClose} width={500}>
      <div className="offboard-dialog-content">
        <p className="offboard-dialog-text">{message}</p>

        <div className="offboard-button-container">
          <button className="dashboard-button offboard-dialog-button primary-button" onClick={onConfirm}>
            {buttonText}
          </button>
          <button className="dashboard-button offboard-dialog-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default OffboardConfirmDialog;
